import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { Menu, X, ArrowRight, LayoutDashboard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { Wordmark } from "@/components/Wordmark";
import { SupportLinkTrigger } from "@/components/SupportTrigger";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/preise", label: "Preise" },
  { to: "/ablauf", label: "Ablauf" },
  { to: "/faq", label: "FAQ" },
] as const;


export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    void supabase.auth.getSession().then(({ data }) => {
      setIsLoggedIn(!!data.session);
    });
    const { data } = supabase.auth.onAuthStateChange((event) => {
      setIsLoggedIn(event === "SIGNED_IN" || event === "USER_UPDATED");
      if (event === "SIGNED_OUT") setIsLoggedIn(false);
    });
    return () => data.subscription.unsubscribe();
  }, []);

  return (
    <header className="sticky top-0 z-40 border-b bg-background/85 backdrop-blur supports-[backdrop-filter]:bg-background/70">
      <div className="mx-auto grid max-w-6xl grid-cols-[minmax(0,1fr)_auto] items-center gap-3 px-4 py-3">
        <Link to="/" className="flex min-w-0 items-center gap-2" onClick={() => setOpen(false)}>
          <Wordmark />
          <span className="hidden text-xs font-medium uppercase tracking-[0.14em] text-foreground/80 sm:inline-block">
            Werbung für Friseursalons
          </span>
        </Link>


        <div className="flex items-center gap-2">
          <nav className="hidden items-center gap-8 md:flex">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="px-1 py-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
                activeProps={{ className: "px-1 py-2 text-sm text-foreground" }}
              >
                {item.label}
              </Link>
            ))}
            <SupportLinkTrigger
              label="Support"
              className="px-1 py-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
            />
          </nav>

          <Button asChild size="sm" className="ml-5 shrink-0">
            <Link to={isLoggedIn ? "/dashboard" : "/auth"}>
              {isLoggedIn ? (
                <>
                  <LayoutDashboard className="mr-1.5 size-4" /> Zur App
                </>
              ) : (
                <>
                  Jetzt starten <ArrowRight className="ml-1 size-4" />
                </>
              )}
            </Link>
          </Button>
          <button
            type="button"
            aria-label={open ? "Menü schließen" : "Menü öffnen"}
            aria-expanded={open}
            onClick={() => setOpen((value) => !value)}
            className="grid size-10 shrink-0 place-items-center rounded-2xl border md:hidden"
          >
            {open ? <X className="size-5" /> : <Menu className="size-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t bg-background px-4 pb-4 pt-2 md:hidden">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className="block rounded-2xl px-2 py-3 text-base text-foreground"
            >
              {item.label}
            </Link>
          ))}
          <SupportLinkTrigger
            label="Support"
            onOpen={() => setOpen(false)}
            className="block w-full rounded-2xl px-2 py-3 text-left text-base text-foreground"
          />
          <Link
            to={isLoggedIn ? "/dashboard" : "/auth"}

            onClick={() => setOpen(false)}
            className="mt-2 block rounded-2xl bg-primary px-2 py-3 text-base font-medium text-primary-foreground"
          >
            {isLoggedIn ? "Zur App" : "Jetzt starten"}
          </Link>
        </nav>
      )}
    </header>
  );
}

